
import React, { useEffect, useRef, useState } from "react";
import banner from "../../assets/Banner_hero.webp";
import { useNavigate } from "react-router-dom";

import "../../Css/Hero.css";
import useCustomerDetails from "../Services/Customer/useCustomerDetails";
import { PiMapPinFill } from "react-icons/pi";
import { HiChevronDown } from "react-icons/hi";

const HeroSection = () => {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const [vehicles, setVehicles] = useState([]);
  const { getAllCityDetailsApi, getAllVehicleDetailsApi } =
    useCustomerDetails();

  useEffect(() => {
    const fetchCities = async () => {
      const response = await getAllCityDetailsApi({
        userId: "",
      });

      if (response?.responseCode === "00") {
        setCities(response?.data || []);

        if (response?.data?.length > 0) {
          setSelectedCity(response.data[0].city);
        }
      }
    };

    fetchCities();
  }, []);

  useEffect(() => {
    const fetchVehicles = async () => {
      const response = await getAllVehicleDetailsApi({
        userId: "",
      });

      if (response?.responseCode === "00") {
        setVehicles(response?.data || []);
      }
    };

    fetchVehicles();
  }, []);
  const navigate = useNavigate();

  return (
    <div className="hero-section relative flex min-h-[720px] flex-col items-center justify-end overflow-hidden px-3 py-6 sm:min-h-[760px] md:min-h-[760px] lg:min-h-[700px]">
      <div className="image-section absolute left-0 top-0 -z-10 h-full w-full">
        <img
          src={banner}
          alt="glare"
          className="hero-img h-full w-full object-cover"
        />
        <div className="image-overlay absolute left-0 top-0 h-full w-full"></div>
      </div>

      <div className="text-section flex w-full justify-center pt-5 md:pb-10 lg:pb-0">
        <div className="flex w-full flex-col items-center justify-center">
          <div
            className="flex w-full max-w-[1150px] flex-col items-center rounded-[20px] p-4 shadow sm:p-6 md:max-w-[560px] md:p-8 lg:max-w-[1150px]"
            style={{
              background: "rgba(237, 241, 249, 0.5)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          >
            <div className="mb-4 flex w-full flex-col items-center justify-between gap-4 lg:flex-row lg:items-start">
              {/* Left Text */}
              <div className="flex w-full flex-col gap-2 text-center lg:max-w-[48%] lg:pl-6 lg:text-left xl:pl-10">
                <h2 className="mx-auto max-w-[420px] text-[20px] font-semibold leading-tight text-[#212529] sm:text-[24px] md:text-[22px] lg:mx-0 lg:max-w-none lg:text-[40px]">
                  Delivery Management Software for Restaurants & Businesses
                </h2>

                <span className="text-base font-light text-gray-700 sm:text-sm md:text-[16px] lg:text-[20px]">
                  Get Your Estimate - Fast & Easy (20 mins)
                </span>
              </div>

              {/* City Dropdown */}
              <div className="flex w-full justify-center lg:mt-16 lg:justify-end lg:pr-6 xl:pr-10">
                <div className="relative flex w-full max-w-[95%] items-center justify-between gap-3 rounded-[20px] bg-gray-100 px-4 py-3 font-light sm:max-w-[320px] sm:px-5 md:max-w-[280px] lg:max-w-[400px] xl:max-w-[320px]">
                  <PiMapPinFill
  className="text-[16px] sm:text-[16px] md:text-[18px] lg:text-[20px]"
  color="#be3624"
/>

                  <span className="whitespace-nowrap text-sm pr-20 text-[#212529] sm:text-[15px]">
                    City:
                  </span>

                  <div ref={dropdownRef} className="relative flex-1">
                    <button
                      type="button"
                      onClick={() => setOpenDropdown(!openDropdown)}
                      className="flex w-full items-center justify-between gap-2 rounded-full bg-white px-4 py-2 text-sm font-medium text-[#212529] shadow-sm transition hover:bg-gray-50 sm:px-5 sm:text-[15px]"
                    >
                      {selectedCity}

                      <HiChevronDown
                        className={`text-lg transition duration-200 ${
                          openDropdown ? "rotate-180" : ""
                        }`}
                      />
                    </button>

                    {openDropdown && (
                      <div className="absolute right-0 top-[115%] z-50 max-h-[240px] w-[180px] overflow-y-auto rounded-xl bg-white py-2 shadow-xl sm:w-[190px] md:w-[110px] lg:w-[120px]">
                        {cities.map((item, index) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => {
                              setSelectedCity(item.city);
                              sessionStorage.setItem("selectedCity", item.city);
                              setOpenDropdown(false);
                            }}
                            className={`block w-full px-4 py-2 text-left text-sm transition hover:bg-gray-100 ${
                              selectedCity === item.city
                                ? "bg-gray-100 font-semibold text-[#be3624]"
                                : "text-gray-700"
                            }`}
                          >
                            {item.city}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Services */}
            <div className="services-container mx-auto grid w-full max-w-[390px] grid-cols-2 gap-x-3 gap-y-6 p-2 md:max-w-[390px] lg:max-w-full lg:grid-cols-4">
              {/* {services.map((service, idx) => ( */}
              {vehicles.map((service, idx) => (
                <div
                  key={idx}
                  onClick={() => {
                    sessionStorage.setItem("selectedCity", selectedCity);
                    sessionStorage.setItem("selectedVehicle", service.name);

                    navigate("/bookings", {
                      state: {
                        city: selectedCity,
                        vehicle: service.name,
                      },
                    });
                  }}
                  className="cursor-pointer mx-auto flex h-[120px] w-[190px] flex-col items-center justify-center rounded-[14px] bg-[#edf1f9] p-3 text-center hover:shadow-md transition sm:h-[130px] sm:w-[200px] md:h-[160px] md:w-[240px] lg:h-[155px] lg:w-full lg:max-w-[190px]"
                >
                  <img
                    // src={service.icon}
                    src={service.image}
                    // alt={service.label}
                    alt={service.name}
                    className="mb-2 h-[52px] w-auto object-contain md:h-[56px] lg:h-[80px]"
                  />

                  <p className="max-w-[110px] text-center text-xs leading-5 text-[#212529] sm:text-sm md:text-[13px] lg:text-[16px]">
                    {/* {service.label} */}
                    {service.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;

